import { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";
import api from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Try restoring session from httpOnly cookie set on previous login.
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    // Token is now delivered only as an httpOnly cookie — no client-side storage.
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.error("Logout request failed:", err);
    }
    setUser(null);
  }, []);

  const value = useMemo(() => ({ user, loading, login, logout }), [user, loading, login, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export const ROLE_LABELS = {
  store_manager: "Store Manager",
  factory_user: "Factory User",
  baikampady_user: "Baikampady User",
  maghveera_user: "Maghveera User",
  qc_manager: "QC Manager",
  top_management: "Top Management",
  super_admin: "Store Manager (Admin)",
};

export const LOCATION_USER_ROLES = ["store_manager", "factory_user", "baikampady_user", "maghveera_user"];

export const ROLE_TO_LOCATION = {
  store_manager: "FACTORY",
  factory_user: "FACTORY",
  baikampady_user: "BAIKAMPADY",
  maghveera_user: "MAGHVEERA",
};

export function isLocationUser(user) {
  return user && LOCATION_USER_ROLES.includes(user.role);
}
export function homeLocationOf(user) {
  return ROLE_TO_LOCATION[user?.role] || null;
}
export function isAdmin(user) {
  return user?.role === "top_management" || user?.role === "super_admin";
}
export function isCEO(user) {
  return isAdmin(user);
}
export function isQC(user) {
  return user?.role === "qc_manager";
}
